import React from "react";
import "./Footer.css";
import { Link } from "react-router-dom";
import logo from "../../src/assets/logowhite.png"

export default function Footer() {
  return (
    <footer className="footer">
      <div className="footer-container">
        {/* Left Section */}
        <div className="footer-section footer-about">
          <div className="footer-logo">
            {/* Replace with your actual logo */}
            <img src={logo} alt="CISL Logo" />
          </div>
          <p>
            Future-Proofing Your Business. Your trusted partner for secure,
            strategic IT solutions and managed services engineered for growth.
          </p>
        </div>

        {/* Middle Sections */}
        <div className="footer-section footer-links">
          <h3>Company</h3>
          <ul>
            <li>
              <Link to="/aboutus">About Us</Link>
            </li>
            <li>
              <Link to="/servicesandproducts">Services</Link>
            </li>
            <li>
              <Link to="/#team">Our Team</Link>
            </li>
          </ul>
        </div>

        <div className="footer-section footer-links">
          <h3>Know More</h3>
          <ul>
            <li>Support</li>
            <li>Privacy Policy</li>
            <li>Terms & Conditions</li>
          </ul>
        </div>

        {/* Right Section */}
        <div className="footer-section footer-contact">
          <h3>Contact Us</h3>
          <div className="footer-input">
            <input type="email" placeholder="Email Goes Here" />
            <button>Send</button>
          </div>
        </div>
      </div>

      <div className="footer-bottom">
        <p>© 2025 “CISL”. All Rights Reserved.</p>
      </div>
    </footer>
  );
}
